import {
  Action,
  ActionType,
  IVerifyPhoneNumberResponse,
} from "models/setting/verifyPhoneNumber";
import createReducer from "redux/createReducer";

export interface VerifyPhoneNumberReducerType {
  loading: boolean;
  error?: string;
  verifyPhoneNumberResponse?: IVerifyPhoneNumberResponse;
}

const defaultState: VerifyPhoneNumberReducerType = {
  loading: false,
  error: undefined,
  verifyPhoneNumberResponse: undefined,
};

export const verifyPhoneNumberReducer =
  createReducer<VerifyPhoneNumberReducerType>(defaultState, {
    [ActionType.VERIFY_PHONE_NUMBER](state: VerifyPhoneNumberReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.VERIFY_PHONE_NUMBER_ERROR](
      state: VerifyPhoneNumberReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.VERIFY_PHONE_NUMBER_SUCCESS](
      state: VerifyPhoneNumberReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        verifyPhoneNumberResponse: action.payload,
      };
    },

    [ActionType.VERIFY_PHONE_NUMBER_RESET](
      state: VerifyPhoneNumberReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        verifyPhoneNumberResponse: undefined,
      };
    },
  });
